<template>
  <div class="detail-page">
    <router-link to="/" class="detail-page__back">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M19 12H5"></path>
        <path d="M12 19l-7-7 7-7"></path>
      </svg>
      <span>返回</span>
    </router-link>

    <!-- ==================== 顶部Banner区域 ==================== -->
    <div class="detail-page__header">
      <div class="detail-page__header-bg"></div>
      <div class="detail-page__header-overlay"></div>
      
      <div class="detail-page__header-content">
        <div class="detail-page__channel-info">
          <span class="detail-page__channel-tag">{{ songData ? songData.fenlei_name : '歌曲' }}</span>
          <h1 class="detail-page__channel-title">{{ songData ? songData.music_name : '加载中...' }}</h1>
          <h2 class="detail-page__channel-subtitle">{{ songData ? songData.singer : '' }}</h2>
          <p class="detail-page__channel-desc">{{ songData ? songData.music_intr : '' }}</p>
          
        </div>

        <div class="detail-page__player">
          <div class="detail-page__album-cover">
            <img :src="songData ? songData.image : ''" :alt="songData ? songData.music_name : ''" />
            <div v-if="songData && songData.isnomf == 1" class="detail-page__vip-badge">VIP</div>
          </div>
          
          <div class="detail-page__now-playing">
            <span class="detail-page__now-playing-tag">正在播放</span>
            <h3 class="detail-page__track-title">{{ songData ? songData.music_name : '' }}</h3>
            <p class="detail-page__track-artist">{{ songData ? songData.singer : '' }} · {{ songData ? songData.shichang : '' }}</p>
            
            <div class="detail-page__player-controls">
              <button class="detail-page__play-btn" @click="playSong">
                <svg v-if="!isPlaying" viewBox="0 0 24 24" fill="currentColor">
                  <polygon points="6 4 20 12 6 20 6 4"></polygon>
                </svg>
                <svg v-else viewBox="0 0 24 24" fill="currentColor">
                  <rect x="6" y="4" width="4" height="16"></rect>
                  <rect x="14" y="4" width="4" height="16"></rect>
                </svg>
                <span>{{ isPlaying ? '暂停' : '播放' }}</span>
              </button>
              <button class="detail-page__control-btn detail-page__control-btn--favorite" :class="{ 'detail-page__control-btn--favorited': songData && songData.status == 1 }" @click="toggleFavorite">
                <svg viewBox="0 0 24 24" :fill="songData && songData.status == 1 ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </button>
              
            </div>
            
            <div class="detail-page__waveform">
              <div class="detail-page__waveform-bar" v-for="i in 80" :key="i" :style="{ height: Math.random() * 80 + 20 + '%' }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== 主内容区域 ==================== -->
    <div class="detail-page__main">
      <div class="detail-page__left">
        <!-- ==================== 相关推荐 ==================== -->
        <div class="detail-page__section">
          <h3 class="detail-page__section-title">相关推荐</h3>
          <div class="detail-page__tracks-list">
            <div class="detail-page__track-item" v-for="track in previousTracks" :key="track.id" @click="goToDetail(track.id)">
              <div class="detail-page__track-cover">
                <img :src="track.image" :alt="track.music_name" />
                <div v-if="track.isnomf == 1" class="detail-page__track-vip">VIP</div>
                <div class="detail-page__track-overlay">
                  <div class="detail-page__track-progress" :style="{ width: track.progress + '%' }"></div>
                </div>
              </div>
              <div class="detail-page__track-info">
                <div class="detail-page__track-name">{{ track.music_name }}</div>
                <div class="detail-page__track-artist-name">{{ track.singer }}</div>
              </div>
              <div class="detail-page__track-time">{{ track.shichang }}</div>
            </div>
          </div>
        </div>

        <!-- ==================== 歌手介绍 ==================== -->
        <div class="detail-page__section">
          <h3 class="detail-page__section-title">歌手介绍</h3>
          <div class="detail-page__about-content">
            <img :src="songData && songData.image || ''" alt="歌手" class="detail-page__about-image" />
            <p class="detail-page__about-text">
              {{ songData && songData.singer_intro || '' }}
            </p>
          </div>
        </div>
      </div>

      <div class="detail-page__right">
        <!-- ==================== 热门歌曲 ==================== -->
        <div class="detail-page__section">
          <h3 class="detail-page__section-title">热门歌曲</h3>
          <div class="detail-page__tracks-list">
            <div class="detail-page__track-item" v-for="track in popularArtists" :key="track.id" @click="goToDetail(track.id)">
              <div class="detail-page__track-cover">
                <img :src="track.image" :alt="track.music_name" />
                <div v-if="track.isnomf == 1" class="detail-page__track-vip">VIP</div>
              </div>
              <div class="detail-page__track-info">
                <div class="detail-page__track-name">{{ track.music_name }}</div>
                <div class="detail-page__track-artist-name">{{ track.singer }}</div>
              </div>
              <div class="detail-page__track-time">{{ track.shichang }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== 相似频道 ==================== -->
    <div class="detail-page__similar">
      <div class="detail-page__similar-inner">
        <h3 class="detail-page__section-title">相似分类</h3>
        <div class="detail-page__similar-grid">
          <div class="detail-page__similar-card" v-for="channel in similarChannels" :key="channel.id" @click="goToDetail(channel.id)">
            <img :src="channel.image" :alt="channel.music_name" class="detail-page__similar-image" />
            <div v-if="channel.isnomf == 1" class="detail-page__similar-vip">VIP</div>
            <div class="detail-page__similar-overlay">
              <button class="detail-page__similar-play">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <polygon points="6 4 20 12 6 20 6 4"></polygon>
                </svg>
              </button>
            </div>
            <div class="detail-page__similar-name">{{ channel.music_name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Xiangqing',
  data() {
    return {
      songData: null,
      previousTracks: [
        { title: 'C调布鲁斯', artist: '艾灵顿公爵', cover: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=duke%20ellington%20jazz%20album%20cover%20blue%20abstract%20swirl&image_size=square', progress: 65, time: '1小时前' },
        { title: '唱吧唱吧唱吧', artist: '本尼·古德曼', cover: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=benny%20goodman%20jazz%20clarinet%20album%20cover%20vintage&image_size=square', progress: 40, time: '2小时前' },
        { title: '兴致盎然', artist: '格伦·米勒', cover: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=glenn%20miller%20big%20band%20jazz%20album%20cover%20swing%20style&image_size=square', progress: 85, time: '3小时前' },
        { title: '月光小夜曲', artist: '格伦·米勒', cover: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=moonlight%20serenade%20jazz%20album%20cover%20romantic%20night&image_size=square', progress: 30, time: '4小时前' },
        { title: '乘坐A列车', artist: '艾灵顿公爵', cover: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=duke%20ellington%20train%20jazz%20album%20cover%20art%20deco&image_size=square', progress: 55, time: '5小时前' }
      ],
      popularArtists: [
        '贝西伯爵', '本尼·古德曼', '格伦·米勒', '艾灵顿公爵',
        '奇克·韦伯', '汤米·多尔西', '哈里·詹姆斯', '厄斯金·霍金斯',
        '吉米·多尔西', '萨姆·多纳休'
      ],
      similarChannels: [
        { name: '现代大乐队', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=modern%20big%20band%20jazz%20radio%20station%20cover%20art%20contemporary%20style&image_size=portrait_4_3' },
        { name: '永恒经典', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=timeless%20classic%20jazz%20radio%20station%20cover%20art%20vinyl%20record%20vintage&image_size=portrait_4_3' },
        { name: '经典爵士', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=classic%20jazz%20radio%20station%20cover%20art%20trumpet%20saxophone%20vintage&image_size=portrait_4_3' },
        { name: '人声传奇', image: 'https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=vocal%20legends%20jazz%20radio%20station%20cover%20art%20female%20singer%20microphone&image_size=portrait_4_3' }
      ]
    }
  },
  computed: {
    currentSongId() {
      return this.$store.state.SongId;
    },
    isPlaying() {
      const isCurrentSong = this.$store.state.SongId === (this.songData ? this.songData.id : -1);
      return isCurrentSong && this.$store.state.isPlaying;
    }
  },
  mounted() {
    const id = this.$route.params.id || this.$route.query.id;
    if (id) {
      this.loadSongDetail(id);
    }
    
    const audio = this.$parent.$refs.audioPlayer;
    if (audio) {
      audio.addEventListener('play', this.onAudioPlay);
      audio.addEventListener('pause', this.onAudioPause);
    }
  },
  beforeDestroy() {
    const audio = this.$parent.$refs.audioPlayer;
    if (audio) {
      audio.removeEventListener('play', this.onAudioPlay);
      audio.removeEventListener('pause', this.onAudioPause);
    }
  },
  watch: {
    '$route.params.id'(newId) {
      if (newId) {
        this.loadSongDetail(newId);
      }
    },
    '$route.query.id'(newId) {
      if (newId) {
        this.loadSongDetail(newId);
      }
    }
  },
  methods: {
    loadSongDetail(id) {
      axios.get('https://xinyinyue.xiangyouhulian.cn/api/index/yydetail', {
        params: {
          id: id,
          username: localStorage.getItem('YousrDL') ? JSON.parse(localStorage.getItem('YousrDL')).username : null
        }
      })
      .then(response => {
        console.log('获取歌曲详情成功:', response);
        const data = response.data;
        if (data.data) {
          const resData = data.data;
          this.songData = resData.detail || resData || {};
          this.previousTracks = resData.same_singer || [];
          this.popularArtists = resData.same_sort || [];
          this.similarChannels = resData.recommend || [];
        } else {
          this.songData = data || {};
        }
      })
      .catch(error => {
        console.error('获取歌曲详情失败:', error);
      });
    },
    playSong() {
      const audio = this.$parent.$refs.audioPlayer;
      if (!audio) return;

      if (this.songData) {
        const currentId = this.$store.state.SongId;
        
        if (currentId === this.songData.id) {
          if (audio.paused) {
            audio.play().catch(() => {});
            this.$store.commit('setPlaying', true);
          } else {
            audio.pause();
            this.$store.commit('setPlaying', false);
          }
        } else {
          this.$store.commit('setSongInfo', this.songData);
          this.$store.commit('setSongId', this.songData.id);
          this.$store.commit('PlayerStatus', true);
          audio.play().catch(() => {});
          this.$store.commit('setPlaying', true);
        }
      }
    },
    onAudioPlay() {
      this.$store.commit('setPlaying', true);
    },
    onAudioPause() {
      this.$store.commit('setPlaying', false);
    },
    goToDetail(id) {
      this.$router.push(`/xiangqing/${id}`);
    },
    toggleFavorite() {
      const savedUser = localStorage.getItem('YousrDL');
      
      console.log(savedUser)
      if (!savedUser) {
        alert('你还没有登录！');
        return;
      }
      
      const songId = this.songData.id;
      if (!songId) {
        alert('请先选择一首歌曲');
        return;
      }
      
      const userInfo = JSON.parse(savedUser);
      
      const username = userInfo.username || '';
      
      if (!username) {
        alert('获取用户信息失败');
        return;
      }
      
      const currentStatus = this.songData.status == 1 ? 0 : 1;
      
      axios.post('https://xinyinyue.xiangyouhulian.cn/api/index/shoucang', {
        username: username,
        gequid: songId,
        status: currentStatus
      })
      .then(response => {
        if (response.data.code === 1) {
          this.songData.status = currentStatus;
          alert(currentStatus === 1 ? '收藏成功' : '取消收藏成功');
        } else {
          alert(response.data.msg || '操作失败');
        }
      })
      .catch(error => {
        console.error('收藏失败:', error);
        alert('收藏失败，请稍后重试');
      });
    }
  }
}
</script>

<style scoped lang="scss">
.detail-page {
  width: 100%;
  min-height: calc(100vh - 80px);
  font-family: 'Arial', Helvetica, sans-serif;
  background-color: #4a1a1a;
  position: relative;

  &__back {
    position: absolute;
    top: 20px;
    left: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 14px;
    padding: 8px 16px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    z-index: 100;
    transition: all 0.2s;

    &:hover {
      color: #ffffff;
      background-color: rgba(0, 0, 0, 0.5);
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }

  &__header {
    position: relative;
    min-height: 320px;
    padding: 30px 40px;
    box-sizing: border-box;
  }

  &__header-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('../../assets/xq.jpg');
    background-size: cover;
    background-position: center center;
  }

  &__header-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to right, rgba(154, 31, 19, 0.9) 0%, rgba(154, 31, 19, 0.7) 50%, rgba(154, 31, 19, 0.5) 100%);
  }

  &__header-content {
    position: relative;
    z-index: 2;
    max-width: 1400px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 260px;
  }

  &__channel-info {
    flex: 1;
  }

  &__channel-tag {
    display: inline-block;
    font-size: 9px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.5);
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom: 8px;
  }

  &__channel-title {
    font-size: 44px;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 4px 0;
    line-height: 1.1;
  }

  &__channel-subtitle {
    font-size: 30px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.8);
    margin: 0 0 12px 0;
    line-height: 1.2;
  }

  &__channel-desc {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.5;
    max-width: 600px;
    margin: 0 0 16px 0;
  }

  &__channel-actions {
    display: flex;
    gap: 10px;
  }

  &__action-btn {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.4);
    background: transparent;
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    svg {
      width: 14px;
      height: 14px;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.8);
    }
  }

  &__player {
    display: flex;
    align-items: flex-end;
    gap: 20px;
    padding-bottom: 10px;
  }

  &__album-cover {
    width: 150px;
    height: 150px;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
    flex-shrink: 0;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__vip-badge {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #f37021;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 3px 8px;
    z-index: 2;
  }

  &__track-vip {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #f37021;
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    z-index: 2;
  }

  &__similar-vip {
    position: absolute;
    top: 0;
    left: 0;
    background-color: #f37021;
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 6px;
    z-index: 2;
  }

  &__now-playing {
    flex: 1;
    min-width: 0;
    padding-bottom: 10px;
  }

  &__now-playing-tag {
    font-size: 9px;
    font-weight: 700;
    color: #f37021;
    text-transform: uppercase;
    letter-spacing: 1.5px;
  }

  &__track-title {
    font-size: 26px;
    font-weight: 700;
    color: #ffffff;
    margin: 6px 0 4px 0;
    line-height: 1.2;
  }

  &__track-artist {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    margin: 0 0 14px 0;
  }

  &__player-controls {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
  }

  &__play-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 20px;
    background-color: #f37021;
    border: none;
    border-radius: 3px;
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    svg {
      width: 18px;
      height: 18px;
    }

    &:hover {
      background-color: #d95e12;
    }
  }

  &__control-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.4);
    background: rgba(0, 0, 0, 0.2);
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    svg {
      width: 16px;
      height: 16px;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.4);
      border-color: rgba(255, 255, 255, 0.8);
    }

    &--favorited {
      color: #ff4d4f;
      background-color: rgba(255, 77, 79, 0.15);
      border-color: #ff4d4f;

      svg {
        fill: #ff4d4f !important;
        stroke: #ff4d4f !important;
      }
    }
  }

  &__favorite-btn {
    width: auto;
    padding: 8px 14px;
    border-radius: 3px;
    gap: 6px;

    span {
      font-size: 12px;
      font-weight: 600;
    }

    &:hover {
      background-color: #b02518;
      border-color: #b02518;
    }
  }

  &__skip-btn {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 14px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 3px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    svg {
      width: 14px;
      height: 14px;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.4);
      color: #ffffff;
    }
  }

  &__waveform {
    display: flex;
    align-items: flex-end;
    gap: 2px;
    height: 36px;

    &-bar {
      width: 4px;
      background-color: rgba(255, 255, 255, 0.7);
      border-radius: 1px;
      animation: waveform 1.2s ease-in-out infinite;
      animation-delay: calc(var(--i, 0) * 0.03s);

      @for $i from 1 through 80 {
        &:nth-child(#{$i}) {
          --i: #{$i};
        }
      }
    }
  }

  &__main {
    display: flex;
    gap: 50px;
    padding: 40px;
    max-width: 1400px;
    margin: 0 auto;
  }

  &__left {
    flex: 1;
  }

  &__right {
    width: 280px;
    flex-shrink: 0;
  }

  &__section {
    margin-bottom: 40px;
  }

  &__section-title {
    font-size: 10px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.5);
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0 0 18px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__tracks-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__track-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    background-color: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.25);
      transform: translateX(4px);
    }
  }

  &__track-cover {
    position: relative;
    width: 52px;
    height: 52px;
    border-radius: 3px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.3);
    }
  }

  &__track-progress {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: #f37021;
    transition: width 0.3s ease;
  }

  &__track-info {
    flex: 1;
    min-width: 0;
  }

  &__track-name {
    font-size: 13px;
    font-weight: 600;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 2px;
  }

  &__track-artist-name {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.55);
  }

  &__track-time {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.4);
    flex-shrink: 0;
  }

  &__about-content {
    display: flex;
    gap: 20px;
  }

  &__about-image {
    width: 150px;
    height: auto;
    border-radius: 4px;
    flex-shrink: 0;
  }

  &__about-text {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.6;
    margin: 0;
  }

  &__artists-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  &__artist-btn {
    padding: 10px 12px;
    background-color: rgba(0, 0, 0, 0.2);
    border: none;
    border-radius: 3px;
    color: rgba(255, 255, 255, 0.75);
    font-size: 12px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(0, 0, 0, 0.35);
      color: #ffffff;
    }
  }

  &__similar {
    padding: 40px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }

  &__similar-inner {
    max-width: 1400px;
    margin: 0 auto;
  }

  &__similar-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  &__similar-card {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.05);

      .detail-page__similar-overlay {
        opacity: 1;
      }
    }
  }

  &__similar-image {
    width: 100%;
    height: auto;
    display: block;
  }

  &__similar-name {
    position: absolute;
    bottom: 12px;
    left: 12px;
    right: 12px;
    font-size: 13px;
    font-weight: 600;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    z-index: 2;
  }

  &__similar-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.6) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &__similar-play {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: #f37021;
    border: 3px solid rgba(255, 255, 255, 0.9);
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;

    svg {
      width: 18px;
      height: 18px;
      margin-left: 2px;
    }

    &:hover {
      background-color: #d95e12;
      transform: scale(1.1);
    }
  }
}

@keyframes waveform {
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}

@media (max-width: 1200px) {
  .detail-page {
    &__similar-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@media (max-width: 768px) {
  .detail-page {
    &__header {
      padding: 25px 20px;
      min-height: 350px;
    }

    &__channel-title {
      font-size: 30px;
    }

    &__channel-subtitle {
      font-size: 20px;
    }

    &__player {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }

    &__album-cover {
      width: 120px;
      height: 120px;
    }

    &__track-title {
      font-size: 20px;
    }

    &__main {
      flex-direction: column;
      padding: 25px 20px;
      gap: 30px;
    }

    &__right {
      width: 100%;
    }

    &__artists-grid {
      grid-template-columns: repeat(3, 1fr);
    }

    &__about-content {
      flex-direction: column;
    }

    &__about-image {
      width: 100%;
    }

    &__similar {
      padding: 25px 20px;
    }

    &__similar-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
